function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useEffect, useState } from 'react';
import { Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { SPRINT_CLAIM_NAME } from '@rd-web-markets/market/dist/constants';
import CompanyClaimGroupEditForm from './CompanyClaimGroupEditForm';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, SaveButton } from '../util/buttons';
import { setLoading } from '../store/features/uiSlice';
import UnsavedChangesPrompt from '../components/UnsavedChangesPrompt';
const CompanyEditForm = _ref => {
  let {
    removeConsultantFromClaim,
    claimTemplates,
    selectedCompany,
    handleSubmit,
    managers = [],
    admins = [],
    consultants = [],
    loading,
    toggleForm,
    questionnaires,
    handleToaster,
    CompanyMarketRelatedFields,
    contracts
  } = _ref;
  const [company, setCompany] = useState(selectedCompany);
  const [finalizedClaims, setFinalizedClaims] = useState(company.claims);
  const [defaultTemplate, setDefaultTemplate] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const user = useSelector(state => state.auth.user);
  const {
    t
  } = useTranslation();
  const handleChange = event => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setHasUnsavedChanges(true);
    setCompany(_objectSpread(_objectSpread({}, company), {}, {
      [event.target.name]: value
    }));
  };
  useEffect(() => {
    setCompany(prevCompany => _objectSpread(_objectSpread({}, prevCompany), {}, {
      id: selectedCompany.id
    }));
  }, [selectedCompany]);
  const submit = e => {
    e.preventDefault();
    handleSubmit(_objectSpread(_objectSpread({}, company), {}, {
      claims: finalizedClaims,
      claim_template_tasks: tasks.filter(task => task.included === true)
    }));
    setHasUnsavedChanges(false);
  };
  const onClaimsChangeSetFinalizedClaims = useCallback(claims => {
    setHasUnsavedChanges(true);
    setFinalizedClaims([...claims]);
  }, [setHasUnsavedChanges]);
  const handleClaimTypeChange = e => {
    setHasUnsavedChanges(true);
    const template = claimTemplates.find(template => template.id === +e);
    const newTasks = [];
    template.claim_template_categories.forEach(category => {
      category.claim_template_tasks.forEach(task => newTasks.push(_objectSpread(_objectSpread({}, task), {}, {
        category_title: category.title,
        included: true
      })));
    });
    setTasks([...newTasks]);
  };
  useEffect(() => {
    const tasks = [];
    const defaultTemplate = claimTemplates.find(template => template.name === SPRINT_CLAIM_NAME);
    setDefaultTemplate(defaultTemplate);
    if (defaultTemplate) {
      defaultTemplate.claim_template_categories.forEach(category => {
        category.claim_template_tasks.forEach(task => tasks.push(_objectSpread(_objectSpread({}, task), {}, {
          category_title: category.title,
          included: true
        })));
      });
    }
    setTasks(tasks);
  }, [claimTemplates]);
  const updateTasks = tasks => {
    setHasUnsavedChanges(true);
    setTasks(tasks);
  };
  const handleClaimGroupChange = event => {
    setHasUnsavedChanges(true);
    const claimGroupCopy = company.claim_group;
    const value = event.target.value;
    claimGroupCopy[event.target.name] = value;
    setCompany(_objectSpread(_objectSpread({}, company), {}, {
      claim_group: claimGroupCopy
    }));
  };
  const handleRadioButtonChange = event => {
    setHasUnsavedChanges(true);
    const claimGroupCopy = company.claim_group;
    const value = event.target.value === 'true' ? true : false;
    claimGroupCopy[event.target.name] = value;
    setCompany(_objectSpread(_objectSpread({}, company), {}, {
      claim_group: claimGroupCopy
    }));
  };
  const lead_consultant_exists = claimGroup => {
    const consultants = company.claim_group.consultants || company.claim_group.consultants_attributes;
    return consultants.find(consultant => consultant.role === 'claim_group_access_lead_consultant');
  };
  const handleConsultantToClaimGroupCreate = consultant => {
    const consultantsAttributes = company.claim_group.consultants_attributes;
    if (!consultantsAttributes.find(cons => cons.id === consultant.id)) {
      if (consultant.role === 'claim_group_access_lead_consultant' && lead_consultant_exists(consultantsAttributes)) {
        handleToaster('Lead consultant already added', 'warning');
      } else {
        setHasUnsavedChanges(true);
        consultantsAttributes.push({
          id: consultant.id,
          email: consultant.email,
          name: consultant.name,
          role: consultant.role
        });
        setCompany(_objectSpread(_objectSpread({}, company), {}, {
          consultants_attributes: consultantsAttributes
        }));
      }
    }
  };
  const changeContactClaimGroup = contact => {
    setHasUnsavedChanges(true);
    const contactsAttributes = company.claim_group.rnd_collaborate_contacts_attributes.filter(cont => cont.name !== contact.name);
    contactsAttributes.push(_objectSpread(_objectSpread({}, contact), {}, {
      claim_group_id: company.claim_group.id
    }));
    setCompany(_objectSpread(_objectSpread({}, company), {}, {
      rnd_collaborate_contacts_attributes: contactsAttributes,
      claim_group: _objectSpread(_objectSpread({}, company.claim_group), {}, {
        rnd_collaborate_contacts_attributes: contactsAttributes
      })
    }));
  };
  const removeContactAttribute = contactName => {
    setHasUnsavedChanges(true);
    const contactsAttributes = company.claim_group.rnd_collaborate_contacts_attributes.filter(cont => cont.name !== contactName);
    setCompany(_objectSpread(_objectSpread({}, company), {}, {
      rnd_collaborate_contacts_attributes: contactsAttributes,
      claim_group: _objectSpread(_objectSpread({}, company.claim_group), {}, {
        rnd_collaborate_contacts_attributes: contactsAttributes
      })
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UnsavedChangesPrompt, {
    hasUnsavedChanges: hasUnsavedChanges
  }), /*#__PURE__*/React.createElement(Form, {
    onSubmit: submit
  }, /*#__PURE__*/React.createElement(CompanyMarketRelatedFields, {
    setLoading: setLoading,
    company: company,
    setCompany: newCompany => {
      setHasUnsavedChanges(true);
      setCompany(newCompany);
    },
    handleChange: handleChange,
    handleToaster: handleToaster,
    contracts: contracts
  }), !company.id && /*#__PURE__*/React.createElement(CompanyClaimGroupEditForm, {
    managers: managers,
    admins: admins,
    changeContactClaimGroup: changeContactClaimGroup,
    removeContactAttribute: removeContactAttribute,
    claimGroupContacts: company.claim_group.rnd_collaborate_contacts_attributes,
    removeConsultantFromClaim: removeConsultantFromClaim,
    claimGroup: company.claim_group,
    handleClaimGroupChange: handleClaimGroupChange,
    handleRadioButtonChange: handleRadioButtonChange,
    tasks: tasks,
    claimTemplates: claimTemplates,
    defaultTemplate: defaultTemplate,
    handleClaimTypeChange: handleClaimTypeChange,
    updateTasks: updateTasks,
    onUpdateConsultants: handleConsultantToClaimGroupCreate,
    consultantsAndAdmins: [...consultants, ...managers, ...admins],
    questionnaires: questionnaires
  }), /*#__PURE__*/React.createElement(Row, {
    className: "modal-footer ".concat(window.MARKET_CONSTANTS.COMPANY_BUTTONS_FORM_BOOTSTRAP_CLASS)
  }, company.id ? /*#__PURE__*/React.createElement(Button, {
    loading: loading,
    variant: "light",
    as: Link,
    to: "/".concat(user.account_type, "/companies/").concat(company.id, "/master")
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_left"), " ", t('back')) : /*#__PURE__*/React.createElement(Button, {
    variant: "light",
    onClick: () => toggleForm()
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_left"), " ", t('back')), /*#__PURE__*/React.createElement(SaveButton, {
    isImmutableUnderReview: true,
    storeIsUnderReviewField: 'isAnyCompanyClaimGroupUnderTechnicalReview',
    loading: loading,
    text: t('save')
  }))));
};
export default CompanyEditForm;